import {
    FlexStart,
    Padding,
    FlexCenter,
    DText,
    FlexEnd,
    FlexBetween,
    CFlexCenter, OrderAnimate, ColorText
} from "../../styles/CommonStyles";
import {
    BuyItem,
    DownArrow,
    SellItem,
    UpArrow,
    MobileHoverWrapper
} from "../../styles/OrderBookStyles";
import { formatNumber } from "../../utils/common";
import Text from "../../utils/Text";
import NoData from "../common/utils/NoData";
import useOrdersBook from "../../hooks/useOrdersBook";
import {useWindowSize} from "../../hooks/common/useWindowSize";
import {useMainContext} from "../../contexts/main";
import {useSocketContent} from "../../contexts/socket-content";
import {MOBILE_SIZE, TABLET_SIZE} from "../../constants/common";
import Loading from "../common/loading/Loading";
import {useRef} from "react";
import {CFlex, Flex} from "../../styles/MarketStyles";
import OrderBookTooltip from "./OrderBookTooltip";



const AllOrders = () => {

    const { width } = useWindowSize()
    const { market } = useMainContext()
    const {trades} = useSocketContent()
    const {
        _sellOrders, _buyOrders,
        sellHover, buyHover,
        setSellHover, setBuyHover,
        sellHoverRef, buyHoverRef,
        sellHoverDetails, buyHoverDetails,
        onSellOrdersHover, onBuyOrdersHover,
        _max, onOrderClicked, loading
    } = useOrdersBook()

    const sellBoxRef = useRef()
    const buyBoxRef = useRef()


    const ResponsiveHoverDetails = ({details}) => {
        return (
            <MobileHoverWrapper>
                <CFlexCenter>
                    <FlexBetween>
                        <DText fontSize="0.55rem"><Text tid="avg-price" />:</DText>
                        <DText fontSize="0.55rem">{formatNumber(details.avg, { type: market?.pair })}</DText>
                    </FlexBetween>
                    <FlexBetween>
                        <DText fontSize="0.55rem"><Text tid="sum" />:</DText>
                        <DText fontSize="0.55rem">{formatNumber(details.sum)}</DText>
                    </FlexBetween>
                    <FlexBetween>
                        <DText fontSize="0.55rem"><Text tid="total" />:</DText>
                        <DText fontSize="0.55rem">{formatNumber(details.total, { type: market?.pair })}</DText>
                    </FlexBetween>
                </CFlexCenter>
            </MobileHoverWrapper>
        )
    }

    return (
        <>
            {(width < TABLET_SIZE && sellHover !== -1) ?
                <ResponsiveHoverDetails details={sellHoverDetails} /> : null
            }
            {(width < TABLET_SIZE && buyHover !== -1) ?
                <ResponsiveHoverDetails details={buyHoverDetails} /> : null
            }
            <CFlex fw height={'calc(100% - 60px)'}>
                <CFlex
                    ref={sellBoxRef}
                    fw
                    height={'48%'}
                    justify={'flex-end'}
                >
                    {_sellOrders?.length ?
                        [..._sellOrders?.slice(0, Math.floor(sellBoxRef.current?.clientHeight / (width > TABLET_SIZE ? 24 : 23)))].reverse().map((order, idx) => (
                            <SellItem
                                onClick={() => onOrderClicked("sell", order.priceUnit)}
                                key={order._id}
                                idx={idx}
                                active={sellHover}
                                onMouseEnter={() => onSellOrdersHover(idx)}
                                onMouseLeave={() => setSellHover(-1)}
                                hotbar={order.price / _max.sell * 100}
                                ref={el => sellHoverRef.current[idx] = el}
                            >
                                <Padding padding="3px 0">
                                    <FlexStart width={width > MOBILE_SIZE ? "30%" : "50%"}>
                                        <ColorText type="number" tradeType={order.type}>
                                            {formatNumber(order.priceUnit)}
                                        </ColorText>
                                    </FlexStart>
                                    <FlexEnd type="number" width={width > MOBILE_SIZE ? "30%" : "50%"}>
                                        <DText>
                                            {formatNumber(order.amount, {point: 6})}
                                        </DText>
                                    </FlexEnd>
                                    {width > MOBILE_SIZE &&
                                        <FlexEnd type="number" width="40%">
                                            <DText>
                                                {formatNumber(order.price)}
                                            </DText>
                                        </FlexEnd>
                                    }
                                </Padding>
                                { order.animate &&
                                    <OrderAnimate />
                                }
                            </SellItem>
                        ))
                        : null
                    }
                    {width > TABLET_SIZE &&
                        <OrderBookTooltip
                            activeIndex={sellHover}
                            ref={sellHoverRef}
                            details={sellHoverDetails}
                        />
                    }

                </CFlex>
                <Flex fw justify={'flex-start'}>
                    <Padding padding="10px 15px">
                        {(_buyOrders?.length || _sellOrders?.length) ?
                            trades?.length ?
                                <>
                                    <DText fontSize={'0.9rem'}>{formatNumber(trades[0].priceUnit)}</DText>
                                    <Padding padding="0 4px">
                                        {
                                            trades[0].type === "buy" ?
                                                <UpArrow size={20} />
                                                :
                                                <DownArrow size={20} />
                                        }
                                    </Padding>
                                </>
                                : <DText>0</DText>
                            :
                            <FlexCenter>
                                <NoData size={50} />
                            </FlexCenter>
                        }
                    </Padding>
                </Flex>
                <CFlex
                    ref={buyBoxRef}
                    fw
                    height={'48%'}
                    justify={'flex-start'}
                >
                    {_buyOrders?.length ?
                        _buyOrders.slice(0, Math.floor(sellBoxRef.current?.clientHeight / (width > TABLET_SIZE ? 24 : 23))).map((order, idx) => (
                            <BuyItem
                                onClick={() => onOrderClicked("buy", order.priceUnit)}
                                key={order._id}
                                idx={idx}
                                active={buyHover}
                                onMouseEnter={() => onBuyOrdersHover(idx)}
                                onMouseLeave={() => setBuyHover(-1)}
                                hotbar={order.price / _max.buy * 100}
                                ref={el => buyHoverRef.current[idx] = el}
                            >
                                <Padding padding="3px 0">
                                    <FlexStart width={width > MOBILE_SIZE ? "30%" : "50%"}>
                                        <ColorText type="number" tradeType={order.type}>
                                            {formatNumber(order.priceUnit)}
                                        </ColorText>
                                    </FlexStart>
                                    <FlexEnd type="number" width={width > MOBILE_SIZE ? "30%" : "50%"}>
                                        <DText>
                                            {formatNumber(order.amount, { point: 6 })}
                                        </DText>
                                    </FlexEnd>
                                    {width > MOBILE_SIZE &&
                                        <FlexEnd type="number" width="40%">
                                            <DText>
                                                {formatNumber(order.price)}
                                            </DText>
                                        </FlexEnd>
                                    }
                                </Padding>

                                { order.animate &&
                                    <OrderAnimate type={'buy'} />
                                }
                            </BuyItem>
                        )) : null}
                    { width > TABLET_SIZE &&
                        <OrderBookTooltip
                            activeIndex={buyHover}
                            ref={buyHoverRef}
                            details={buyHoverDetails}
                        />
                    }

                </CFlex>
            </CFlex>

        <Loading loading={loading} />
        </>
    )
}


export default AllOrders;
